export default "__VITE_ASSET__b3aeb9a5__"